module.exports = __webpack_public_path__ + "img/GAME_RECYCLING2.dba5c8ba.jpg";